module.exports = __webpack_public_path__ + "img/dark_logo_transparent.bd0f5143.svg";